import React from "react";
import logo from "./logo.svg";
import "./App.css";

import Home from "./pages/home";
import Login from "./pages/login";
import Register from "./pages/register";
import ResetPassword from "./pages/resetPassword";
import SetAppointment from "./pages/setAppointment";
import AdminDashboard from "./pages/adminDashboard";
import MyAppointments from "./pages/myAppointments";
import AccountSettings from "./pages/accountSettings";
import MyBooklet from "./pages/myBooklet";

import CmsPanel from "./pages/cms/CmsPanel";
import CmsSectionEditor from "./pages/cms/CmsSectionEditor";
import CmsMediaManager from "./pages/cms/CmsMediaManager";

import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import EmailVerified from "./pages/emailVerified";
import { NotificationProvider } from "./contexts/notificationContext";
import { SiteContentProvider } from "./contexts/siteContentContext";

function App() {
  return (
    <SiteContentProvider>
      <NotificationProvider>
        <Router>
          <div className="App">
            <Routes>
              <Route path="/home" element={<Home />} />
              <Route path="" element={<Navigate to="/home" />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/email/verified" element={<EmailVerified />} />
              <Route path="/set-appointment" element={<SetAppointment />} />
              <Route path="/my-appointments" element={<MyAppointments />} />
              <Route path="/my-booklet" element={<MyBooklet />} />
              <Route path="/account-settings" element={<AccountSettings />} />
              <Route path="/admin-dashboard" element={<AdminDashboard />} />
              {/* CMS Routes */}
              <Route path="/cms" element={<CmsPanel />} />
              <Route path="/cms/section/:group" element={<CmsSectionEditor />} />
              <Route path="/cms/media" element={<CmsMediaManager />} />
            </Routes>
          </div>
        </Router>
      </NotificationProvider>
    </SiteContentProvider>
  );
}

export default App;
